import HideNavScrollContainer from "../../Componant/PageLayout/HideNavScroll";

const HideNavScroll = () => {
  return (
    <div className="page-body">
      <HideNavScrollContainer />
    </div>
  );
};

export default HideNavScroll;
